import './winners-history.css';

import { Trophy, ExternalLink, Crown, Users } from 'lucide-react';
import { Link } from 'react-router';
import { ROUTES } from '../../../routes';

interface Winner {
  position: number;
  username: string;
  token: number;
  prize: number;
  isReferrer: boolean;
}

const PREVIOUS_WINNERS: Winner[] = [
  {
    position: 1,
    username: 'VikingoImperial',
    token: 7777,
    prize: 5000,
    isReferrer: false,
  },
  {
    position: 1,
    username: 'RomanoLegendario',
    token: 8888,
    prize: 500,
    isReferrer: true,
  },
  {
    position: 2,
    username: 'GuerreroAmatista',
    token: 1234,
    prize: 2500,
    isReferrer: false,
  },
  {
    position: 2,
    username: 'CazadorPiedras',
    token: 9999,
    prize: 250,
    isReferrer: true,
  },
  {
    position: 3,
    username: 'EmperadorOscuro',
    token: 5555,
    prize: 1000,
    isReferrer: false,
  },
  {
    position: 3,
    username: 'SenadorMistico',
    token: 3333,
    prize: 100,
    isReferrer: true,
  },
];

export function WinnersHistory() {
  return (
    <div className="isg-winners">
      <div className="isg-winners-header">
        <div className="isg-winners-titlebox">
          <Trophy className="isg-winners-icon" stroke="#CAFB10" />
          <h2 className="isg-winners-title">
            Ganadores de la Temporada Anterior
          </h2>
        </div>

        <Link
          to={ROUTES.WINNING_HISTORY}
          target="_top"
          className="isg-winners-link"
        >
          Ver Historial Completo
          <ExternalLink className="isg-winners-link-icon" stroke="#90F7FF" />
        </Link>
      </div>

      <div className="isg-winners-grid">
        {PREVIOUS_WINNERS.map((winner, index) => (
          <div key={index} className={`isg-winner-card pos-${winner.position}`}>
            <div className="isg-winner-top">
              <div className="isg-winner-user">
                {winner.isReferrer ? (
                  <Users className="isg-winner-icon-ref" />
                ) : (
                  <Crown className="isg-winner-crown" />
                )}

                <div>
                  <div className="isg-winner-meta">
                    {winner.position}°{' '}
                    {winner.isReferrer ? 'Referidor' : 'Ganador'}
                  </div>
                  <div className="isg-winner-name">{winner.username}</div>
                </div>
              </div>
            </div>

            <div className="isg-winner-info">
              <div className="isg-winner-row">
                <span className="isg-winner-label">Token:</span>
                <span className="isg-winner-token">#{winner.token}</span>
              </div>

              <div className="isg-winner-row">
                <span className="isg-winner-label">Premio:</span>
                <span className="isg-winner-prize">
                  €{winner.prize.toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="isg-winners-footer">
        <Trophy className="isg-winners-footer-icon" />
        <p className="isg-winners-footer-text">
          <span>Sistema de premios:</span> Los 3 primeros lugares reciben
          premio, junto con sus referidores (usuarios que les invitaron al
          juego).
        </p>
      </div>
    </div>
  );
}
